import React, {useState} from 'react';
import {Box, Button, Step, StepContent, StepLabel, Stepper, Typography} from '@mui/material';

const PhotoRecommender = () => {
    const [activeStep, setActiveStep] = useState(0);

    const handleCapture = async () => {
        try {
            const video: any = document.getElementById('video');
            video.srcObject = await navigator.mediaDevices.getUserMedia({video: true});
        } catch (err: any) {
            console.error(err);
        }
    };

    const handleSnap = async () => {
        const video: any = document.getElementById('video');
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context: any = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert canvas image to data URL
        const dataURL = canvas.toDataURL('image/jpeg');
        const preview: any = document.getElementById('preview');
        preview.src = dataURL;
        preview.style.display = 'block';

        const preview2: any = document.getElementById('preview2');
        preview2.src = dataURL;
        preview2.style.display = 'block';

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    return (
        <Box mx={"0.5em"} mt={"1em"}>
            <Stepper orientation="vertical">
                <Step key={0} completed={0 < activeStep} active={0 === activeStep} expanded={0 === activeStep}>
                    <StepLabel>Take photo</StepLabel>
                    <StepContent>
                        <Box display="flex" flexDirection="column" gap={2} justifyContent={"center"}>
                            <Button variant={"contained"} color="primary" onClick={handleCapture}>
                                Start capture
                            </Button>
                            <video id="video" width="auto" height="auto" autoPlay></video>
                            <Button variant={"contained"} color="primary" onClick={handleSnap}>
                                Snap
                            </Button>
                            <img alt="preview" id="preview" width="auto" height="auto" style={{display: 'none'}}/>
                        </Box>
                    </StepContent>
                </Step>
                <Step key={1} completed={1 < activeStep} active={1 === activeStep} expanded={1 === activeStep}>
                    <StepLabel>Preview Photo</StepLabel>
                    <StepContent TransitionProps={{unmountOnExit: false}}>
                        <Typography variant="body1">Please confirm the photo</Typography>
                        <img alt="preview" id="preview2" width="240" height="auto" style={{display: 'none'}}/>
                    </StepContent>
                </Step>
            </Stepper>
        </Box>
    );
};

export default PhotoRecommender;